export default __webpack_public_path__ + "static/media/botoes_laterais_02.a0b57258.mp3";